import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fillTopic } from '@wellesley/ws'
import { User, UserFull } from '@wellesley/openapi'
import { getUserNameWithDomain } from 'helpers/getUserNameWithDomain'
import { wsSubscribe, wsUnSubscribe } from '@wellesley/host-remote/api/actions'

export type AnyUser = User | UserFull

type UseUserSubscribeProps<T> = {
  id: string
  user?: T
}

export const useUserSubscribe = <T extends AnyUser>({
  id,
  user,
}: UseUserSubscribeProps<T>) => {
  const dispatch = useDispatch()

  const subscriptionName = fillTopic('user#$username', {
    username: user ? getUserNameWithDomain(user).slice(1) : '',
  })

  const subscriptionId = `${id}-${user?.username}`

  useEffect(() => {
    if (!user?.username) return

    dispatch(
      wsSubscribe({
        id: subscriptionId,
        topics: [subscriptionName],
      }),
    )

    return () => {
      dispatch(wsUnSubscribe(subscriptionId))
    }
  }, [user?.username])

  return {
    subscriptionName,
  }
}
